import { isEmpty } from '@ember/utils'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'
import type { NormalizedInterval } from 'date-fns'

export interface WorkingAtGradeLevelTotalsByGradeData {
  grade_position: number
  student_count: number
  below: number
  at: number
  above: number
}

export interface WorkingAtGradeLevelTotalsByGradeResponse {
  working_at_grade_level_totals_by_grade: WorkingAtGradeLevelTotalsByGradeData[]
}

export async function workingAtGradeLevelTotalsByGrade(
  this: StudentEventsService,
  product: LegacyProductMs | LegacyProductRe | LegacyProductRex,
  scope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<WorkingAtGradeLevelTotalsByGradeData[]>> {
  if (isEmpty(scope.ids)) return null

  const url = this.buildUrl('working_at_grade_level_totals_by_grade', product, scope)
  const query = this.buildQuery(scope, period)

  const data = await this.fetchData<WorkingAtGradeLevelTotalsByGradeResponse>(url, query)
  if (!data) return null

  const { working_at_grade_level_totals_by_grade: totalsByGrade } = data

  if (totalsByGrade.length === 0) return null

  return totalsByGrade
    .filter((grade) => grade.grade_position !== null)
    .sort((a, b) => a.grade_position - b.grade_position)
}
